import { useSyncExternalStore } from 'react';
import type { MessengerThread } from '@/api/client';
import {
  getMessengerThreadsList,
  subscribeMessengerThreadsList,
} from '@/components/Messenger/cache/messengerThreadsStore';

export function useMessengerThreadsList(): readonly MessengerThread[] {
  return useSyncExternalStore(
    subscribeMessengerThreadsList,
    getMessengerThreadsList,
    getMessengerThreadsList
  );
}
